import * as React from 'react';
import { Button } from '@cian/ui-kit/button';

interface ISubmitButtonProps {
  buttonText: string;

  onClick(): void;
}

export const SubmitButton: React.FC<ISubmitButtonProps> = ({ onClick, buttonText }) => (
  <Button onClick={onClick} size="XS">
    {buttonText}
  </Button>
);

SubmitButton.displayName = 'SubmitButton';
